function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, errors, name, showCreateEntityModal) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'inline-cohorts-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        const stagedCohort = $helpers.getStagedCohort();;
        __jade_nodes = __jade_nodes.concat(($helpers.isOpen() && showCreateEntityModal) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-create-entity-modal", {
            "attrs": {
              'entity-type': `cohort`,
              'modal-title': `Save Cohort`,
              'initial-description': stagedCohort.description,
              'initial-name': name || stagedCohort.name,
              open: true,
            },
            "on": {
              cancel: $helpers.closeEntityModal,
              save: $helpers.saveStagedCohort,
            },
            "props": {
              existingEntityNames: $helpers.getCohortNames(),
            },
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-modal", {
            "attrs": $helpers.getModalAttributes(),
            "on": {
              change: $helpers.handleModalStateChange
            },
            "class": {
              'inline-cohorts-modal': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("section", {
              "class": {
                'inline-cohorts-modal-scroll-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("section", {
                "class": {
                  'inline-cohorts-modal-header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("h2", {
                  "class": {
                    'modal-title': true,
                    'mp-font-size-xl': true,
                    'mp-font-weight-bold': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat($helpers.getTitle());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("section", {
                "class": {
                  'inline-cohorts-workspace': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("section", {
                  "class": {
                    'inline-cohorts-builder': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(($helpers.isOpen()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("section", {
                      "class": {
                        'inline-cohorts-name-input': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-input", {
                        "attrs": {
                          placeholder: `Add name`,
                          label: `Name`,
                          necessary: `required`,
                          maxlength: 190,
                          'validation-status': errors.has($helpers.CohortsModalError.NameRequired) ? `invalid` : (name ? `valid` : ``),
                          'error-message': errors.has($helpers.CohortsModalError.NameRequired) ? `Enter a name for your cohort.` : ``,
                        },
                        "props": {
                          value: name,
                        },
                        "on": {
                          input: $helpers.handleNameInputChange,
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'inline-cohorts-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Build cohort");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("section", {
                      "class": {
                        'inline-cohorts-builder-qb-wrapper': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-cohorts-query-builder", {
                        "on": {
                          stagedCohortUpdated: ev => $helpers.handleStagedCohortUpdate(ev.detail.stagedCohort),
                          track: $helpers.trackCohortsBuilderEvent,
                        },
                        "attrs": {
                          'track-name': $attr(`track-name`),
                          'staged-cohort': stagedCohort,
                          'project-id': $attr(`project-id`),
                          'project-has-cohorts': $attr(`project-has-cohorts`),
                          'data-group-id': $attr(`data-group-id`),
                          'user-id': $attr(`user-id`),
                        },
                        "props": {
                          context: $helpers.getMPContext(),
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'inline-cohorts-builder-footer': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'left-controls': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(($attr(`can-save`)) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": {
                            size: `small`,
                            theme: `secondary`,
                            disabled: $helpers.isSaveDisabled()
                          },
                          "on": {
                            click: $helpers.openEntityModal
                          },
                          "class": {
                            'inline-cohorts-button': true,
                            'cohorts-save-button': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("Save");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'right-controls': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": {
                          size: `small`,
                          theme: `tertiary`
                        },
                        "on": {
                          click: $helpers.closeModal
                        },
                        "class": {
                          'inline-cohorts-button': true,
                          'cohorts-cancel-button': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Cancel");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": {
                          size: `small`,
                          theme: `primary`,
                          disabled: $helpers.isSaveDisabled()
                        },
                        "on": {
                          click: $helpers.commitStagedCohort
                        },
                        "class": {
                          'inline-cohorts-button': true,
                          'cohorts-apply-button': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(($attr(`is-new-cohort-definition`)) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("Add " + ($attr(`type`)) + "");;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("Update " + ($attr(`type`)) + "");;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "errors" in locals ? locals.errors : typeof errors !== "undefined" ? errors : undefined, "name" in locals ? locals.name : typeof name !== "undefined" ? name : undefined, "showCreateEntityModal" in locals ? locals.showCreateEntityModal : typeof showCreateEntityModal !== "undefined" ? showCreateEntityModal : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;